<template>
  <div>
    <div class="line_block_bg">
      <div style="font-weight: bold">数据档案->{{ type | filterType }} </div>
      <div class="search">
        <el-input placeholder="输入指标名称关键词" prefix-icon="el-icon-search" v-model="keyword" style="width: 208px"
          @blur="searchValue">
        </el-input>
      </div>
    </div>
    <template v-if="list.length">
      <div class="" v-for="(item, index) in list" :key="index">
        <div class="title" style="">
          {{ item.title }}
        </div>
        <div class="cell" v-for="(childItem, childIndex) in item.indexList" :key="childIndex">
          <div class="cellTitle wz-mt-3 wz-mb-1">
            <div class="name">{{ childItem.indexType }}</div>
            <div class="" @click="lsClick(childItem, item.tableName)">
              <!-- <a-button>详细数据</a-button> -->
              <el-button type="primary" size="mini" icon="el-icon-more">详细数据</el-button>
            </div>
          </div>
          <div class="cellList">
            <div class="descriptions" v-for="(keyInfo, keyIdx) in childItem.keyList" :key="keyIdx">
              <div class="descriptionsTitle">
                <div>{{ keyInfo.name }} </div>
                <div>{{ keyInfo.unit }}</div>
              </div>
              <div class="descriptionsContent" v-if="!keyInfo.edit">
                <div>
                  {{ keyInfo.value || "--" }}
                </div>
                <div>
                  <el-button v-if="userRole != 'SPORT_CENTER_ADMIN'" type="default" size="mini" icon="el-icon-edit"
                    circle @click="clickEdit(index, childIndex, keyIdx)" plain></el-button>
                  <!-- <a-icon type="edit" style="" @click="clickEdit(index, childIndex, keyIdx)" /> -->
                </div>
              </div>
              <div class="descriptionsContent" v-else>
                <input class="flex-1 input margin-r15 pad-x15 pad-y10" v-model="list[index].indexList[childIndex].keyList[keyIdx].putVal
          " placeholder="请输入内容" type="text" />
                <div class="white-s-nowrap">
                  <el-button type="primary" @click="finishEdit(index, childIndex, keyIdx)" style="display: inline-block"
                    class="margin-r5">保存</el-button>
                  <el-button type="default" @click="closeEdit(index, childIndex, keyIdx)"
                    style="display: inline-block">取消</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <a-empty :image="simpleImage" />
    </template>
    <a-modal :visible="visible" :title="indexType" @ok="visible = false" @cancel="visible = false" width="800px"
      wrapClassName="full-modal">
      <!-- <div class="clear">
        <div class="fl">
          <a-select
            ref="select"
            v-model="value1"
            style="width: 120px"
            @change="handleChange"
          >
            <a-select-option
              v-for="item in historyList"
              :key="item.key"
              :value="item.key"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>

        
        <div class="rangeSelect fr colorW">
          <a-month-picker
            :value="month"
            v-if="range === 2"
            class="ml15"
            style="width: 200px !important; display: inline-block"
            v-model="month"
            :format="monthFormat"
            @change="onChange1"
          />
          <a-week-picker
            v-else
            :value="week"
            format="YYYY年-第wo"
            class="ml15"
            style="width: 200px !important; display: inline-block"
            @change="onChange"
          />
          <span
            class="ml15"
            :class="range == 2 ? 'rangeSelectActive' : ''"
            @click="dateChange(2)"
            >月</span
          >
          <span
            class="ml15"
            :class="range == 1 ? 'rangeSelectActive' : ''"
            @click="dateChange(1)"
            >周</span
          >
        </div>
      </div> -->
      <div class="">
        <div class="popupHeader">
          <div class="">
            <a-select ref="select" v-model="value1" style="width: 180px" @change="handleChange">
              <a-select-option v-for="item in historyList" :key="item.key" :value="item.key">{{ item.name
                }}</a-select-option>
            </a-select>
          </div>
          <div class="value">当前值：{{ newValue }}</div>
        </div>

        <div class="">
          <a-table bordered :columns="columns" :data-source="table" :rowKey="(record, index) => {
          return index;
        }
          ">
          </a-table>
        </div>
      </div>
      <!-- <div v-if="shows" id="lsjl" style="width: 100%; height: 400px"></div>
      <a-empty v-else /> -->
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { Empty } from "ant-design-vue";
import * as API_Member from "@/api/member/member";
const columns = [
  {
    title: "时间",
    dataIndex: "date",
    key: "date",
    align: "center",
    customRender: function (val) {
      return val ? moment(val).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  {
    title: "值",
    dataIndex: "value",
    key: "value",
    align: "center",
  },
];

export default {
  props: ["type"],
  data() {
    return {
      columns,
      visible: false,
      shows: false,
      userRole: null,
      indexType: "",
      value1: "",
      lsjlEcharts: "",
      keyword: "",
      newValue: '',
      range: 2,
      monthFormat: "YYYY/MM",
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      list: [],
      historyList: [],
      table: [],
      moment: moment(),
      week: moment(),
      month: moment(),
      startDate: moment().day(1).hours(0).minute(0).seconds(0).valueOf(),
      endDate: moment().day(7).hours(23).minute(59).seconds(59).valueOf(),
      lsjlOptions: {
        xAxis: {
          type: "category",
          data: ["08/07", "08/06", "08/05", "08/04", "08/03", "08/02", "08/01"],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff", //更改坐标轴文字颜色
              fontSize: 14, //更改坐标轴文字大小
            },
          },
        },
        yAxis: {
          min: "dataMin",
          max: "dataMax",
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff", //更改坐标轴文字颜色
              fontSize: 14, //更改坐标轴文字大小
            },
          },
        },
        series: [
          {
            data: [80, 80, 75, 78, 77, 69, 70],
            type: "line",
            symbol: "circle", // 设置折点为实心圆
            symbolSize: 6, // 折点大小
            itemStyle: {
              // 折点颜色
              color: "#108ee9",
            },
            lineStyle: {
              // 设置线条颜色
              color: "#108ee9",
            },
          },
        ],
      },
    };
  },
  watch: {
    historyList(v) {
      if (v.length) {
        // 当数据存在 ，echart显示第一个选择
        this.value1 = v[0].key;
        this.ecahrtsxl();
      }
    },
    "type": {
      handler(newValue, oldValue) {
        // console.log(newValue,oldValue);
        this.type = newValue
        this.getList();
      },
      // immediate: true
    }
  },
  created() {
    this.getList();
    this.userRole =
      (this.$store.state.user.roles.length &&
        this.$store.state.user.roles[0].name) ||
      "";
    console.log(this.userRole, "userRole");
  },
  methods: {
    async getList() {
      const getData = await API_Member.getHealthData({
        type: this.type,
        memberId: this.$route.query.id || this.loginInfo.id,
        keyword: this.keyword || "",
      });
      if (getData.code == 200) {
        if (getData.data.length > 0) {
          getData.data.forEach((item) => {
            if (item.time) {
              let time = String(item.time);
              item.time =
                time.substr(0, 4) +
                "/" +
                time.substr(4, 2) +
                "/" +
                time.substr(6, 2) +
                " " +
                time.substr(8, 2) +
                ":" +
                time.substr(10, 2);
            }
            if (item.indexList) {
              item.indexList.forEach((idxInfo) => {
                if (idxInfo.keyList) {
                  idxInfo.keyList.forEach((keyInfo) => {
                    keyInfo.putVal = keyInfo.value; // 添加初始参数编辑参数
                    keyInfo.edit = false; // 添加初始参数是否编辑
                  });
                }
              });
            }
          });
        }
        console.log("getData.data--", getData.data);
        this.list = getData.data;

      }
    },
    searchValue(e) {
      this.getList();
    },
    // 点击编辑
    clickEdit(index, idx, kdx) {
      this.list[index].indexList[idx].keyList[kdx].putVal =
        this.list[index].indexList[idx].keyList[kdx].value;
      this.list[index].indexList[idx].keyList[kdx].edit = true;
      console.log(this.list);
    },
    // 取消编辑
    closeEdit(index, idx, kdx) {
      this.list[index].indexList[idx].keyList[kdx].edit = false;
    },
    // 确认编辑
    async finishEdit(index, idx, kdx) {
      if (
        !this.list[index].indexList[idx].keyList[kdx].putVal ||
        this.list[index].indexList[idx].keyList[kdx].putVal ==
        this.list[index].indexList[idx].keyList[kdx].value
      ) {
        this.$message.error("未作出修改！");
        return false;
      }
      const getData = await API_Member.addHealthData({
        memberId: this.$route.query.id * 1 || this.loginInfo.id,
        tableName: this.list[index].tableName,
        indexType: this.list[index].indexList[idx].indexType,
        fieldName: this.list[index].indexList[idx].keyList[kdx].name,
        field: this.list[index].indexList[idx].keyList[kdx].key,
        value: this.list[index].indexList[idx].keyList[kdx].putVal,
      });
      if (getData.code == 200) {
        this.$message.success("编辑成功！");
        this.closeEdit(index, idx, kdx);
        this.getList();
      }
    },
    lsClick({ keyList, indexType }, tableName) {
      this.historyList = [];
      this.tableName = tableName;
      this.indexType = indexType;
      this.value1 = "";
      this.visible = true;
      this.startDate = moment().startOf("month").valueOf();
      this.endDate = moment().endOf("month").valueOf();
      this.getHistoricalData(this.startDate, this.endDate);
    },
    // 获取历史数据
    async getHistoricalData(start, end) {
      let obj = {
        start,
        end,
        indexType: this.indexType,
        memberId: this.$route.query.id || this.loginInfo.id,
        table: this.tableName,
      };
      console.log(obj);
      const res = await API_Member.getHistory(obj);
      //   if (!res.data.length) {
      //     this.initlsjlEcharts([], []);
      //     this.shows = false;
      //     return;
      //   }
      //   this.shows = true;
      this.historyList = res.data;
      this.table = res.data[0].list;
      // console.log(this.table);
      //   console.log(datas,xdatas)
    },
    handleChange(e) {
      console.log(e);
      // this.indexType = e
      // this.getHistoricalData(this.startDate, this.endDate);
      this.ecahrtsxl();
    },
    // 改变周
    onChange(weekData) {
      this.week = weekData;
      const startDate = (this.startDate = moment(weekData)
        .isoWeekday(1)
        .startOf("day")
        .day(1)
        .valueOf()); // 周一日期
      const endDate = (this.endDate = moment(weekData)
        .isoWeekday(1)
        .endOf("day")
        .day(7)
        .valueOf()); // 周日日期
      this.getHistoricalData(startDate, endDate);
    },
    onChange1(weekData) {
      this.month = weekData;
      this.startDate = moment(weekData).startOf("month").valueOf();
      this.endDate = moment(weekData).endOf("month").valueOf();
      this.getHistoricalData(this.startDate, this.endDate);
    },
    // 改变周月
    dateChange(e) {
      this.range = e;
      if (e === 1) {
        this.onChange(moment());
      } else {
        this.onChange1(moment());
      }
    },
    // 渲染数据
    ecahrtsxl() {
      let dataList = this.historyList.filter(
        (item) => item.key === this.value1
      )[0];
      console.log(dataList, "dataList");

      let datas = dataList.list.map((item) => item.value);
      let xdatas = dataList.list.map((item) =>
        moment(item.date).format("YYYY-MM-DD")
      );
      this.table = dataList.list;
      this.newValue = dataList.list.length ? dataList.list[0].value : '--'
      //   console.log(datas, xdatas);
      //   setTimeout(() => {
      //     this.initlsjlEcharts(xdatas, datas);
      //   }, 0);
    },
    // 初始化实时体重图表
    initlsjlEcharts(xData, yData) {
      this.lsjlEcharts = this.$echarts.init(document.getElementById("lsjl"));
      // 初始化图表数据
      this.setlsjlEcharts(xData, yData);
    },
    // 设置实时体重图表数据
    setlsjlEcharts(xData, yData) {
      this.lsjlOptions.xAxis.data = xData;
      this.lsjlOptions.series[0].data = yData;
      console.log(this.lsjlOptions);
      // 绘制图表
      this.lsjlEcharts.setOption(this.lsjlOptions);
    },
    onSearch() { },
  },
  filters: {
    filterType(val) {
      switch (val) {
        case 2:
          return '医务监督'
        case 3:
          return '体能指标'
        case 4:
          return '伤病档案'
        case 5:
          return '心理调控'
        case 7:
          return '营养补充'
        case 8:
          return '战术分析'
        case 6:
          return '技术分析'
      }
    }
  }
};
</script>

<style scoped lang="less">
.line_block_bg {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 0 10px 15px;
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.search {
  margin-left: auto;
  padding-right: 15px;
}

.title {
  font-weight: bold;
  font-size: 18px;
  color: #fff;
  margin-top: 15px;
}

.title::before {
  content: "▋";
  display: inline-block;
  color: #40a1ff;
}

.popupHeader {
  display: flex;
  align-items: center;
  color: #fff;
  margin-bottom: 22px;
}

.value {
  margin-left: 42px;
}

.cellTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .name {
    font-weight: bold;
    font-size: 16px;
    color: #999;
  }

  .name::before {
    content: "●";
    margin-right: 3px;
  }
}

.cellList {
  .descriptions {
    display: flex;
    align-items: center;
    width: 100%;
    height: 80px;
  }

  .descriptionsTitle {
    padding: 0 22px;
    width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  .descriptionsContent {
    flex: 1;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
    height: 100%;
    font-weight: bold;
  }
}

.rangeSelect {
  margin-left: -5%;
}

.rangeSelect span {
  width: 50px;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
  line-height: 50px;
  float: right;
  color: #ffffff;
}

.rangeSelectActive {
  border-color: rgba(64, 158, 255, 1) !important;
  color: #ffffff !important;
  background: rgba(64, 158, 255, 1);
}
</style>
